import React from "react";
import {
    convertDistance,
    getDistanceUnit,
    getFlightsByRoute,
    getMeasurements, hasMultipleAirports,
    log,
    NullableType,
    toAirportCity
} from "./Tools";
import {useSelector} from "react-redux";
import {LocationsType, StateBaseType} from "./store";
import uniq from "lodash/uniq";
import {FlightType, LoginType} from "./actions/action";

// function component
function FlightHover() {

    //const dispatch = useDispatch();
    //const [captchaPassed, setCaptchaPassed] = useState(false);

    const hoveredFlight: any = useSelector<StateBaseType>((state) => state.reducer.hoveredFlight);
    const locations: LocationsType = useSelector<StateBaseType, LocationsType>((state) => state.reducer.locations);
    const flights: FlightType[] = useSelector<StateBaseType, FlightType[]>((state) => state.reducer.flights);
    const user: NullableType<LoginType> = useSelector<StateBaseType, NullableType<LoginType>>((state) => state.reducer.user);

    if (!hoveredFlight || !hoveredFlight.flight) {
        log('skipped hoverflight');
        return null;
    }

    const measurements = getMeasurements();
    let x, y;

    x = hoveredFlight.hoveredFlightPosition.x - 225;
    if (x < 0) {
        x = hoveredFlight.hoveredFlightPosition.x + 25;
    }
    if (x + 200 > measurements.width) {
        x = hoveredFlight.hoveredFlightPosition.x - 100;
    }

    if (measurements.height < (hoveredFlight.hoveredFlightPosition.y + 200)) {
        y = hoveredFlight.hoveredFlightPosition.y - 125;
    } else {
        y = hoveredFlight.hoveredFlightPosition.y + 25;
    }

    const divStyle = {
        top: '' + y + 'px',
        left: '' + x + 'px'
    };

    const city = toAirportCity(locations);
    const multipleAirports = hasMultipleAirports(locations);
    const flightsWithSameRoute = getFlightsByRoute(flights, hoveredFlight.flight, locations);
    const routeYears = uniq(flightsWithSameRoute.map(flight => flight.date.split('-')[0]));

    const convertedDistance = convertDistance(hoveredFlight.flight.distance, user!.km);
    const unit = getDistanceUnit(user!.km);

    log('render Flighthover');
    return (
        <div className="hoverFlight" style={divStyle}>
            {city(hoveredFlight.flight.from)}
            {multipleAirports(hoveredFlight.flight.from) ? (`(${hoveredFlight.flight.from})`) : ''}
            -
            {city(hoveredFlight.flight.to)}
            {multipleAirports(hoveredFlight.flight.to) ? (`(${hoveredFlight.flight.to})`) : ''}
            <br/>
            <br/>
            {flightsWithSameRoute.length} flight{flightsWithSameRoute.length > 1 ? 's' : ''}
            &nbsp;
            {routeYears[0]} {routeYears.length > 1 ? ('- ' + routeYears[routeYears.length - 1]) : ''}
            <br/>
            {convertedDistance} {unit}
        </div>
    );
}

export default FlightHover;
